// import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const cacheResource = '/admin/cache'

export default {
  getCacheRefreshKeys() {
    return OperationsRepository.get(`${cacheResource}/refresh-keys`)
  },
}
